// extracted by mini-css-extract-plugin
export default {"single-campaign":"SingleCampaign_single-campaign__A4nzF"};